
export default {
  props: ['name'],
  computed: {
    isRTL() {
      return this.$i18n.locale == 'ar';
    },
  },
};
